import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_CONTRACT_LABOR_CONFIRMED } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_CONTRACT_LABOR_CONFIRMED
    }
};

export const contractLaborConfirmedSlice = createSlice({
    name: 'contractLaborConfirmed',
    initialState,
    reducers: {
        searchContractLaborConfirmed: (state, action) => {
            state.search = action.payload;
        },
        searchContractLaborConfirmedPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = contractLaborConfirmedSlice;
export const { searchContractLaborConfirmed, searchContractLaborConfirmedPageFirst } = actions

export const selectSearchContractLaborConfirmed = (state) => state?.features?.contractLaborConfirmed?.search

export default reducer


